// Wrapper for redux-saga to ensure proper Metro bundler compatibility
// @ts-ignore
const sagaModule = require('redux-saga');
export default sagaModule.default || sagaModule;

